module.exports = __webpack_public_path__ + "img/desk-illu.656d4dd7.svg";